
<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /* text-align: center; */
        color: #2c3e50;
        /* margin-top: 60px; */
    }

    .flex {
        display: flex;
    }

    .flex.col {
        flex-direction: column;
    }

    .Container {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    @media only screen and (max-width: 640px) {
        .Container {
            max-width: 640px;
        }
    }

    @media only screen and (min-width: 768px) {
        .Container {
            max-width: 768px;
        }
    }

    @media only screen and (min-width: 1024px) {
        .Container {
            max-width: 1024px;
        }
    }

    /* @media only screen and (min-width: 1280px) {
                            .Container {
                                max-width: 1280px;
                            }
                        } */
</style>


<template lang="pug">

//- img( alt="Vue logo" src="./assets/logo.png" )

.Container
    //- Form( :title="definition.title" :action="definition.action" :pages="definition.pages" )
    Form

</template>


<script>

import { defineComponent, reactive, } from 'vue'

// import useState from './state'

import Form from './components/Form.vue'


export default defineComponent( {

    name: 'App',

    components: {
        Form,
    },

    // setup() {

    //     const { definition } = useState()



    //     return {
    //         definition,
    //     }

    // },

} )
</script>

